import { NavigationSubItem } from "../navigation-item"

export class RewardsLockSubItem extends NavigationSubItem {
  readonly id = "rewards"
  readonly label = "Rewards"
  readonly href = "/rewards"
  readonly iconName = "rewards-icon"
  readonly isExternal = false
  readonly tabs = []
}
